<template>
  <div :class="`input-wrapper -${inkline.options.colorMode === 'system' ? colorMode : inkline.options.colorMode}`">
    <div class="input">
    <textarea
      v-model="inputValue"
      :placeholder="placeholder"
      ref="textarea"
      :style="`min-height:${heightArea}px;`"
    />
    </div>
  </div>
</template>

<script>
import colorMode from '@/_mixins/colorMode'
export default {
  inject: ['inkline'],
  props: {
    modelValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    heightArea: 0
  }),
  mixins: [colorMode],
  mounted () {
    this.resize()
  },
  computed: {
    inputValue: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
        this.resize()
      }
    }
  },
  methods: {
    resize () {
      if (this.$refs.textarea.scrollHeight > this.$refs.textarea.clientHeight) {
        this.heightArea = this.$refs.textarea.scrollHeight
      }
    }
  }
}
</script>
